<template>
  <div class="relative h-40 overflow-hidden shadow">
    <img :src="category.photo.path" alt=""
         class="w-full" v-if="category.photo">
    <div class="absolute bg-gray-500/50 w-full h-full flex items-center justify-center top-0">
      <span class="text-white text-2xl font-bold">{{ category.name }}</span>
    </div>
  </div>

  <div class="grid grid-cols-2 p-2" v-if="category.products">

    <VerticalProductCard v-for="product in category.products"
                         :key="product.id"
                         :product="product"
                         @click="selectProduct(product)"/>

  </div>

  <div class="grid grid-cols-2 p-2" v-if="category.services">

    <VerticalServiceCard v-for="service in category.services"
                         :key="service.id"
                         :service="service"
                         @click="selectedService = service; modalService = true"/>

  </div>

  <VModal :title="`سفارش ${selectedService.name}`" :show="modalService" @click="modalService = false">
    <div class="overflow-y-scroll flex flex-col h-52">
    <span class="text-sm text-gray-700">{{ selectedService.description }}</span>
    <form @submit.prevent="">
      <VInput class="w-full mt-2" placeholder="تعداد" v-model="serviceRequest.count"
              type="number" v-if="selectedService.limit_type !== 'none'"/>

      <textarea class="w-full border p-2 rounded-lg text-black mt-2"
                placeholder="توضیحات..." v-model="serviceRequest.description"></textarea>

      <VButton class="w-full mt-4" @click="submitServiceRequest">ثبت</VButton>
    </form>
  </div>
  </VModal>

  <VModal :title="`سفارش ${selectedProduct.name}`" :show="modalProduct" @click="modalProduct = false">

    <form @submit.prevent="addToCart">
      <div class="flex justify-between items-center">
        <span class="bg-yellow-300 rounded-md p-2"
              @click="incrementCount">+</span>
        <span>{{ selectedProduct.count }}</span>
        <span class="bg-yellow-300 rounded-md p-2"
              @click="decrementCount">-</span>
      </div>

      <textarea class="w-full border p-2 rounded-lg text-black mt-2"
                placeholder="توضیحات..." v-model="selectedProduct.orderDescription"></textarea>

      <VButton class="w-full mt-4">ثبت</VButton>
    </form>

  </VModal>

</template>

<script>
import {getCategoryProducts, postServiceRequest} from "@/API/API";
import VerticalProductCard from "@/components/VerticalProductCard";
import VerticalServiceCard from "@/components/VerticalServiceCard";
import VModal from "@/components/General/VModal";
import VInput from "@/components/General/VInput";
import VButton from "@/components/General/VButton";

export default {
  name: "CategoryProducts",
  components: {VButton, VInput, VModal, VerticalServiceCard, VerticalProductCard},
  data() {
    return {
      category: {},

      modalService: false,
      selectedService: {},
      serviceRequest: {},

      modalProduct: false,
      selectedProduct: {},
    }
  },
  async created() {
    this.category = (await getCategoryProducts(this.$route.params.id)).data
  },
  methods: {
    submitServiceRequest() {
      let serviceRequest = {
        'room_number': localStorage.getItem('roomNumber'),
        'service_id': this.selectedService.id,
        'count': this.serviceRequest.count,
        'description': this.serviceRequest.description
      }

      postServiceRequest(serviceRequest)
          .then(() => {
            this.modalService = false
            this.$swal({
              icon: 'success',
              title: 'موفق',
              text: 'درخواست با موفقیت ثبت شد.',
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
          })
          .catch(err => {
            this.$swal({
              icon: 'error',
              title: 'خطا',
              text: err.response.data,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
          })
          .finally(() => {
            this.modalService = false
            this.serviceRequest = {}
          })

    },
    selectProduct(product) {
      this.selectedProduct = product
      this.selectedProduct.count = this.$store.getters.productCount(this.selectedProduct.id)
      this.selectedProduct.orderDescription = this.$store.getters.productDescription(this.selectedProduct.id)
      this.modalProduct = true
    },

    incrementCount() {
      if (this.selectedProduct.count + 1 > this.selectedProduct.inventory) {
        return
      }
      this.selectedProduct.count++
    },
    decrementCount() {
      if (this.selectedProduct.count - 1 < 0) {
        return
      }
      this.selectedProduct.count--
    },
    addToCart() {
      if (this.selectedProduct.count > 0) {
        this.$store.dispatch('addToCart', this.selectedProduct)
      } else {
        this.$store.dispatch('removeProduct', this.selectedProduct)
      }
      this.modalProduct = false
    },
  }
}
</script>

<style scoped>

</style>